
@if (isLocationCard()) {
  <app-end-location-main
    [title]="title()"
    [startDate]="startDate()"
  />
  
} @else {
  <app-regular-main
    [id]="id()"
    [title]="title()"
    [indexCard]="indexCard()"
    [durationMinutes]="durationMinutes()"
    [isDuration15Minutes]="isDuration15Minutes()"
  />
}
